import { useSession } from '@/features/auth/hooks/useSession'
import { useFeedback } from '@/app/providers/FeedbackContext'

export function SessionErrorBanner() {
  const { sessionError, clearSessionError } = useSession()
  const { openModal } = useFeedback()

  if (!sessionError) return null

  const handleReport = () => {
    openModal({
      type: 'bug_report',
      errorInfo: {
        message: sessionError.message,
        stack: `Operation: ${sessionError.operation}\nTimestamp: ${new Date(sessionError.timestamp).toISOString()}`,
      },
    })
    clearSessionError()
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '1rem',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'var(--color-danger-muted)',
        border: '1px solid var(--color-danger-muted)',
        borderRadius: '0.5rem',
        padding: '0.75rem 1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        boxShadow: 'var(--popover-shadow, 0 4px 6px -1px rgba(0, 0, 0, 0.1))',
        zIndex: 9999,
        maxWidth: '90vw',
      }}
    >
      <span style={{ color: 'var(--color-danger)', fontSize: '0.875rem' }}>
        {sessionError.message}
      </span>
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <button
          onClick={handleReport}
          style={{
            padding: '0.25rem 0.75rem',
            fontSize: '0.75rem',
            backgroundColor: 'var(--color-danger)',
            color: 'white',
            border: 'none',
            borderRadius: '0.25rem',
            cursor: 'pointer',
          }}
        >
          Report
        </button>
        <button
          onClick={clearSessionError}
          style={{
            padding: '0.25rem 0.75rem',
            fontSize: '0.75rem',
            backgroundColor: 'transparent',
            color: 'var(--color-text-muted)',
            border: '1px solid var(--color-border-strong)',
            borderRadius: '0.25rem',
            cursor: 'pointer',
          }}
        >
          Dismiss
        </button>
      </div>
    </div>
  )
}
